import Toast from 'react-native-root-toast';

import { formatParlevelAndQuantity, valueExists } from '../../../common/utils/utils';

export const VIEW_MODES = {
	GRID: 'grid',
	LIST: 'list',
};

export const MARKET_VIEW_MODES = {
	PRODUCTS: 'products',
	ASSETS: 'assets',
};

export const resolveNumericValue = (value, fallback = 0) => {
	if (Number.isFinite(value)) {
		return value;
	}

	const parsedValue = Number(value);
	return Number.isFinite(parsedValue) ? parsedValue : fallback;
};

export const resolveEditableNumericValue = (value, {
	fallback = 0,
	allowNull = false,
} = {}) => {
	if (value === '') {
		return allowNull ? null : fallback;
	}

	if (!valueExists(value)) {
		return allowNull ? null : fallback;
	}

	return resolveNumericValue(value, fallback);
};

export const resolveQuantityLabel = (item) => {
	const quantity = formatParlevelAndQuantity(item.quantity, item.product);
	const parlevel = formatParlevelAndQuantity(item.parlevel, item.product);
	const capacityExists = item.capacity !== null && item.capacity !== undefined;
	if (!capacityExists) {
		return `${quantity} / ${parlevel}`;
	}

	const capacity = formatParlevelAndQuantity(item.capacity, item.product);
	return `${quantity} / ${parlevel} / ${capacity}`;
};

export const resolveSelectionLabel = (item) => {
	if (item.selection) {
		return item.selection;
	}
	if (Number.isFinite(item?.row) && Number.isFinite(item?.column)) {
		return `${item.row}-${item.column}`;
	}
	return 'N/A';
};

export const showProductNameToast = (item) => {
	const productName = item?.product?.name || 'Empty selection';
	Toast.show(productName, {
		duration: Toast.durations.SHORT,
	});
};
